import { Skeleton } from '@mantine/core';
import ErrorFallback from 'components/common/ErrorFallback';
import Slider from 'components/common/Slider';
import { defaultIcon } from 'pages/DetailGiftCategory';
import React, { memo, useEffect, useState } from 'react';
import { withErrorBoundary } from 'react-error-boundary';
import { Link } from 'react-router-dom';
import { convertObjToArr } from 'utils';
import GiftItem from '../GiftItem';

const CategoryGift = (props) => {
  const { listGift, code, info } = props;
  const [listGiftState, setListGiftState] = useState([
    {
      content: (
        <>
          <Skeleton width={150} height={108} mr={8} />
          <Skeleton width={150} height={8} mt={8} />
          <Skeleton width={100} height={8} mt={8} />
          <Skeleton width={50} height={8} mt={10} mb={10} />
        </>
      ),
    },
    {
      content: (
        <>
          <Skeleton width={150} height={108} mr={8} />
          <Skeleton width={150} height={8} mt={8} />
          <Skeleton width={100} height={8} mt={8} />
          <Skeleton width={50} height={8} mt={10} mb={10} />
        </>
      ),
    },
  ]);

  const creatItemSlider = (arr) => {
    let result = arr.map((gift) => {
      return {
        content: <GiftItem giftData={gift} />,
      };
    });
    return result;
  };
  const handleUpdateInfoGiftCategory = () => {
    localStorage.setItem(
      'typeGift',
      JSON.stringify({
        title: info.title || 'Quà tặng',
        icon: info.icon || defaultIcon,
      })
    );
  };

  useEffect(() => {
    if (convertObjToArr(listGift).length > 0) {
      let result = creatItemSlider(listGift);
      setListGiftState(result);
    }
  }, [listGift]);

  return (
    listGiftState && (
      <div className='mb-4 bg-white rounded-lg'>
        <div className='py-3 px-6 text-18px font-averta-bold flex justify-between'>
          <p className='text-black text-18px lg:text-20px'>{info.title}</p>
          {code && (
            <Link
              to={`/pages/loyalty-store/detail?code=${code}`}
              onClick={handleUpdateInfoGiftCategory}
            >
              <p className='text-14px text-0090F0 font-bold'>Thêm</p>
            </Link>
          )}
        </div>
        <div className='pb-3 pl-6 lg:px-6'>
          <div className='block'>
            <Slider
              content={listGiftState}
              settings={{
                withIndicators: false,
                withControls: false,
                slideSize: '150',
                loop: false,
                dragFree: true,
                autoPlay: false,
                // slidesToScroll: 1,
                align: 'start',
                slideGap: 'sm',
                breakpoints: [
                  { maxWidth: 'md', slideSize: '50%', slideGap: 0 },
                  { maxWidth: 'sm', slideSize: '40%', slideGap: 0 },
                ],
              }}
            />
          </div>
        </div>
      </div>
    )
  );
};

export default withErrorBoundary(memo(CategoryGift), {
  FallbackComponent: ErrorFallback,
});
